import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./QuizSuccess.css";

const QuizSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isHovering, setIsHovering] = useState(false);

  const { quizCode, selectedQuestions } = location.state || {};

  return (
    <div className="success-container">
      <div className="success-card">
        <h1 className="success-title">Quiz Created Successfully!</h1>
        <p className="success-text">
          Share this code with your students to allow them to take the quiz:
          <span className="success-quiz-code">{quizCode}</span>
        </p>

        {selectedQuestions && selectedQuestions.length > 0 ? (
          <table className="success-table">
            <thead>
              <tr>
                <th>Question</th>
                <th>Spec Code</th>
                <th>Subject</th>
              </tr>
            </thead>
            <tbody>
              {selectedQuestions.map((question, index) => (
                <tr key={index}>
                  <td>
                    {question.questionText ? (
                      question.questionText
                    ) : (
                      <span style={{ fontStyle: "italic" }}>Image-based question</span>
                    )}
                    {question.questionImageURL && (
                      <img
                        src={question.questionImageURL}
                        alt="Question"
                        className="success-question-image"
                      />
                    )}
                  </td>
                  <td>{question.specCode}</td>
                  <td>{question.subject}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="success-no-questions">
            No questions selected or available.
          </p>
        )}

        <button
          onClick={() => navigate("/dashboard")}
          className="success-button"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
          style={{
            transform: isHovering ? "translateY(-2px)" : "none",
            boxShadow: isHovering
              ? "0 6px 12px rgba(41, 128, 185, 0.3)"
              : "0 4px 8px rgba(41, 128, 185, 0.2)",
          }}
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default QuizSuccess;
